import React from 'react';
function ArrowHw({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.25 13.0474v5.3166m0 0h5.3166m-5.3166 0L18.3421 5.25m-4.5666-.8165h5.3166v5.3166"
      />
    </svg>
  );
}

export default ArrowHw;
